export default "__VITE_ASSET__B_t_EKJM__"